import * as d3 from 'd3';
import { useEffect, useRef } from 'react';


const Legend = ({legend, view, yAxisFormat}) => {

    if(view === 1){
        var screen_width_fac = 0.675;
        var graphWidthActual = window.screen.width*screen_width_fac;
        var graphHeightActual = 200;
    } else if(view === 3){
        var graphWidthActual = 600;
        var graphHeightActual = 175;
    } else if(view === 5){
        var graphWidthActual = 300;
        var graphHeightActual = 700;
    } else {
        var graphWidthActual = 300;
        var graphHeightActual = 200;
    }

    const legendRef = useRef();

    const draw = () => {

        const margin = {top: 5, right: 5, bottom: 5, left: 5};
        const graphWidth = graphWidthActual - margin.left - margin.right;
        const graphHeight = graphHeightActual - margin.top - margin.bottom;

        const legendBar = d3.select(legendRef.current);

        return {legendBar, margin, graphWidth, graphHeight}
    };

    const update = (legendBar, legend, graphWidth, graphHeight) => {
        if (view === 1){
            var row = 0;
            var row_label = 0;

            // legendBar.selectAll('.legend')
            // .data(legend)
            // .join('rect')
            // .attr('class', 'legend')
            // .attr("x", (d, i) => {
            //     return 12+(200*(i%5));
            // })
            // .attr("y", (d, i) => {
            //     if(i%5 != 0 || i<5){
            //         return 12+(25*row);
            //     } else {
            //         row = row+1;
            //     }
            //     return 12+(25*row);
            // })
            // .attr("width", 15)
            // .attr("height", 15)
            // .attr("fill", (d, i) => d.color);
            
            legendBar.selectAll('.legend')
            .data(legend)
            .join('circle')
            .attr('class', 'legend')
            .attr("cx", (d, i) => {
                return 24+(200*(i%5));
            })
            .attr("cy", (d, i) => {
                if(i%5 != 0 || i<5){
                    return 20+(25*row);
                } else {
                    row = row+1;
                }
                return 20+(25*row);
            })
            .attr("r", 9)
            .attr("fill", (d, i) => d.color);

        legendBar.selectAll('.label')
            .data(legend)
            .join('text')
            .attr('class', 'label')
            .attr("x", (d, i) => {
                return 40+(200*(i%5));
            })
            .attr("y", (d, i) => {
                if(i%5 != 0 || i < 5){
                    return 25+(25*row_label);
                } else {
                    row_label = row_label+1;
                }
                return 25+(25*row_label);
            })
            .text(d => d.label);
    } else if(view === 2){
            // legendBar.selectAll('.legend')
            // .data(legend)
            // .join('rect')
            // .attr('class', 'legend')
            // .attr("x", (d, i) => 0)
            // .attr("y", (d, i) => 14+20*i)
            // .attr("width", 15)
            // .attr("height", 15)
            // .attr("fill", (d, i) => d.color);
        
            legendBar.selectAll('.legend')
            .data(legend)
            .join('circle')
            .attr('class', 'legend')
            .attr("cx", (d, i) => 10)
            .attr("cy", (d, i) => 17+23*i)
            .attr("r", 9)
            .attr("fill", (d, i) => d.color);

        legendBar.selectAll('.label')
            .data(legend)
            .join('text')
            .attr('class', 'label')
            .attr("x", (d, i) => 25)
            .attr("y", (d, i) => 21.5+23*i)
            .text(d => d.label);

        }else if(view === 3){
            var row = 0;
            var row_label = 0;

            // legendBar.selectAll('.legend')
            // .data(legend)
            // .join('rect')
            // .attr('class', 'legend')
            // .attr("x", (d, i) => {
            //     return 10+(200*(i%3));
            // })
            // .attr("y", (d, i) => {
            //     if(i%3 != 0 || i<3){
            //         return 10+(25*row);
            //     } else {
            //         row = row+1;
            //     }
            //     return 10+(25*row);
            // })
            // .attr("width", 15)
            // .attr("height", 15)
            // .attr("fill", (d, i) => d.color);

            legendBar.selectAll('.legend')
            .data(legend)
            .join('circle')
            .attr('class', 'legend')
            .attr("cx", (d, i) => {
                return 24+(200*(i%3));
            })
            .attr("cy", (d, i) => {
                if(i%3 != 0 || i<3){
                    return 19+(25*row);
                } else {
                    row = row+1;
                }
                return 19+(25*row);
            })
            .attr("r", 9)
            .attr("fill", (d, i) => d.color);
        
        legendBar.selectAll('.label')
            .data(legend)
            .join('text')
            .attr('class', 'label')
            .attr("x", (d, i) => {
                return 40+(200*(i%3));
            })
            .attr("y", (d, i) => {
                if(i%3 != 0 || i < 2){
                    return 24+(25*row_label);
                } else {
                    row_label = row_label+1;
                }
                return 24+(25*row_label);
            })
            .text(d => d.label);
        }else if (view === 5){
            legendBar.selectAll('.legend')
            .data(legend)
            .join('rect')
            .attr('class', 'legend')
            .attr("x", (d, i) => 0)
            .attr("y", (d, i) => 14+10*i)
            .attr("width", 25)
            .attr("height", 15)
            .attr("fill", (d, i) => d.color);

        legendBar.selectAll('.label')
            .data(legend)
            .join('text')
            .attr('class', 'label')
            .attr("x", (d, i) => 25)
            .attr("y", (d, i) => 25+10*i)
            .text((d,i) => {
                if (i%4 === 0)
                {
                    return '|- '+d.label
                } else {
                    return '|';
                }
            });
        } else {
        // legendBar.selectAll('.legend')
        // .data(legend)
        // .join('rect')
        // .attr('class', 'legend')
        // .attr("x", (d, i) => 0)
        // .attr("y", (d, i) => 14+20*i)
        // .attr("width", 15)
        // .attr("height", 15)
        // .attr("fill", (d, i) => d.color);
    
        legendBar.selectAll('.legend')
            .data(legend)
            .join('circle')
            .attr('class', 'legend')
            .attr("cx", (d, i) => 10)
            .attr("cy", (d, i) => 17+23*i)
            .attr("r", 9)
            .attr("fill", (d, i) => d.color);

        legendBar.selectAll('.label')
            .data(legend)
            .join('text')
            .attr('class', 'label')
            .attr("x", (d, i) => 25)
            .attr("y", (d, i) => 21.5+23*i)
            .text(d => d.label);
    }
    }
    useEffect(() => {
        const {legendBar, graphWidth, graphHeight} = draw();
        update(legendBar, legend, graphWidth, graphHeight);
    }, [legend, yAxisFormat]);

    return ( 
        <svg width={graphWidthActual} height={graphHeightActual}>
             <g ref={legendRef} className="legend" />
        </svg>
     );
}
 
export default Legend;